import { render } from "./TransactionTypes.vue?vue&type=template&id=53ad347d"
import script from "./TransactionTypes.vue?vue&type=script&lang=js"
export * from "./TransactionTypes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__